import React from "react";
import { FormBlockType } from "modules/forms/hooks/usefetchForm";

export type DividerBlockData = {
    text: string;
};

export type DividerBlockType = Omit<FormBlockType, "data"> & {
    data: DividerBlockData;
};

export default function DividerBlock(block: DividerBlockType) {
    const { text } = block.data;

    return (
        <div className={"relative my-6 h-px border-b"}>
            &nbsp;
            <div className={"absolute -top-3 w-full text-center"}>
                {text && (
                    <span
                        className={"bg-card px-2 font-custom-family text-textColor"}
                    >{text}</span>
                )}
            </div>
        </div>
    );
}
